import iconTime from "../../../../assets/icon_time.svg";
import iconOff from "../../../../assets/icon_off.svg";
import iconAdd from "../../../../assets/icon_add.svg";
import iconOpen from "../../../../assets/icon_open.svg";
import iconClose from "../../../../assets/icon_close.svg";
import iconStore from "../../../../assets/icon_store.svg";
import iconBaseball from "../../../../assets/icon_baseball.svg";
import iconHomefield from "../../../../assets/icon_homefield.svg";
import iconAwayfield from "../../../../assets/icon_awayfield.svg";
import useSelectBrand from "../../../../hooks/styles/useSelectBrand";
import { useSelector } from "react-redux";

//영업중, 휴업중 등 뱃지 (디자인 미정)
const StatusBadge = ({ isOpen, bgColor }) => {
  const statusMap = {
    OP: {
      text: "영업중",
      icon: iconOpen,
      color: "text-black",
      bg: `bg-${bgColor}`,
    },
    PR: {
      text: "영업준비중",
      icon: iconClose,
      color: "text-white",
      bg: "bg-zinc-700",
    },
    CL: {
      text: "영업종료",
      icon: iconClose,
      color: "text-white",
      bg: "bg-zinc-700",
    },
    OF: {
      text: "휴점일",
      icon: iconClose,
      color: "text-white",
      bg: "bg-zinc-700",
    },
  };

  const { text, icon, color, bg } = statusMap[isOpen] || {
    text: "",
    icon: null,
    color: "text-white",
    bg: "bg-zinc-700",
  };

  return (
    <span
      className={`inline-flex items-center justify-center py-2 px-3 text-sm rounded-[50px] ${color} ${bg} gap-1.5`}
    >
      {icon && <img src={icon} alt="" />}
      {text}
    </span>
  );
};

const LandersBadge = ({ status, stadium }) => {
  const statusMap = {
    HOME: {
      text: "HOME",
      icon: iconHomefield,
      style: "pr-6"
    },
    AWAY: {
      text: "AWAY",
      icon: iconAwayfield,
      style: "pr-6"
    }
  };

  const { text, icon, style } = statusMap[status] || {
    text: "NONGAME",
    icon: null,
  };

  return (
    <span
      className={`flex w-full items-center justify-center py-3 text-lg font-semibold rounded-[90px] text-brand-text bg-[#82181A] gap-4 ${style}`}
    >
      {icon && <img src={icon} alt="" className="w-14 h-12"/>}
      {text} 
      {/* ({stadium}) */}
    </span>
  );
};


//점포 상세 정보 (영업정보, 휴점일, 주소)
const InfoItem = ({ icon, title, content, showBaseballIcon = false, brandId }) => {
  const contentClass = title === "휴점일" || title === "휴무일" ? "text-red-400" : "text-gray-600";
  const isContentJSX = typeof content === "object" && content !== null && !(content instanceof String);
  const landersClass = brandId === "LD" && "bg-brand-secondary px-1 rounded-full pr-2 text-brand-text";
  const landersTitleClass = brandId === "LD" && "!text-brand-text";
  
  return (
    <li className="flex items-start gap-2">
      <div className={`flex shrink-0 items-center w-[100px] gap-1 font-semibold ${landersClass}`}>
        {showBaseballIcon ? (
          <span className="w-6 h-6 flex items-center justify-center">
            <img src={iconBaseball} alt="야구공" />
          </span>
        ) : (
          <span className="w-5 h-5 flex items-center justify-center">
            <img src={icon} alt={title} />
          </span>
        )}
        <p>{title}</p>
      </div>
      {isContentJSX ? (
        <div className={`font-medium break-words ${contentClass} ${landersTitleClass}`}>{content}</div>
      ) : (
        <p className={`font-medium break-words ${contentClass} ${landersTitleClass}`}>{content}</p>
      )}
    </li>
  );
};

//점포 상세 정보 외 다른 정보들(현금 없는 매장)
const ExtraInfoItem = ({ icon, title = {}, content }) => {
  return (
    <li className="flex gap-1 leading-6">
      <div className="flex items-center w-auto gap-2 font-semibold ">
        <span className="shrink-0">
          <img src={icon} alt="" />
        </span>
        <p>{title}</p>
      </div>
      <p className="flex items-center text-sm font-medium text-gray-600">
        {content}
      </p>
    </li>
  );
};

// 주소를 포맷팅하는 함수
const formatAddress = (address1, address2) => {
  if (!address1) return null;
  return (
    <>
      {address1}
      {address2 && (
        <>
          <br />
          {address2}
        </>
      )}
    </>
  );
};

//점포 정보
const StoreInfo = ({
  branchName,
  storeClose,
  workingTime,
  location,
  isOpen,
  cashless,
  fc,
  homeAway,
  stadium
}) => {
  const { color } = useSelectBrand();
  const brandId = useSelector((state) => state.checkArsStatus.brandId);
  const isLanders = brandId === "LD";
  
  return (
    <div className="mb-5">
      {
        isLanders ? (
        <div className="mb-4 text-3xl font-semibold">
          <LandersBadge status={homeAway} stadium={stadium} />
        </div>
        ) : (
        <div className="mb-4 text-3xl font-semibold">
          <h2 className="inline mr-2.5 align-middle">{branchName}</h2>
          <StatusBadge isOpen={isOpen} bgColor={color} />
        </div>
        )
      }
      <ul className="gap-1 flex flex-col">
        <InfoItem
          icon={iconOff}
          title={`${isLanders ? "휴무일" : "휴점일"}`}
          content={`${isLanders ? '홈경기 없는 주말/공휴일, 매주 월요일' : storeClose?.join(", ")}`}
          showBaseballIcon={isLanders}  
          brandId={brandId}
        />

        {isLanders ? (
          <InfoItem
            icon={iconTime}
            title="운영시간"
            content={
              homeAway ? (              
              <div className="flex flex-col gap-1">
                <span className="inline-flex items-center gap-1">
                  <span className="px-2 w-16 text-brand-text text-sm rounded-full border-[1px] flex justify-center">HOME</span>
                  <span>10:00 ~ 19:00</span>
                </span>
                <span className="inline-flex items-center gap-1">
                  <span className="px-2 w-16 text-brand-text text-sm rounded-full border-[1px] flex justify-center">AWAY</span>
                  <span>10:00 ~ 17:00</span>
                </span>
              </div>) : (           
                <div className="flex flex-col gap-1">
                    <span>10:00 ~ 17:00</span>
                </div>
              )
            }
            showBaseballIcon={isLanders}
            brandId={brandId}
          />
        ) : (
          <InfoItem icon={iconTime} title="영업시간" content={workingTime} showBaseballIcon={isLanders} />
        )}
        <InfoItem
          icon={iconAdd}
          title="주소"
          content={`${isLanders ? '인천광역시 미추홀구 매소홀로 618' : `${location?.address1} ${location?.address2}`}`}
          showBaseballIcon={isLanders}
          brandId={brandId}
        />
        {cashless === "Y" &&
          (fc === "Y" ? (
            <ExtraInfoItem
              icon={iconStore}
              title="현금없는매장"
              content="(상품권 및 이마티콘 사용 불가점)"
            />
          ) : (
            <ExtraInfoItem icon={iconStore} title="현금없는매장" />
          ))}
      </ul>
    </div>
  );
};

export default StoreInfo;
